import { importProvidersFrom, NgModule } from '@angular/core';
 import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { NgOptimizedImage } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { RegistrationPageService } from './registration-pages/registration-page/registration-page.service';

import { MatSelectCountryLangToken, MatSelectCountryModule } from '@angular-material-extensions/select-country';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { MatCheckboxModule } from '@angular/material/checkbox';


import { LucideAngularModule } from 'lucide-angular';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';

import { RouterModule } from '@angular/router';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DyteComponentsModule } from '@dytesdk/angular-ui-kit';
import { StreamAutocompleteTextareaModule, StreamChatModule } from 'stream-chat-angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';

import { JobComponent } from './main-pages/company/jobs-page/job/job.component';


@NgModule( {
  imports: [
    MatCardModule,
    MatIconModule,
    SharedModule,
    MatExpansionModule,
    DyteComponentsModule,
    MatDividerModule,
    MatChipsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    StreamAutocompleteTextareaModule,
    StreamChatModule,
    MatMenuModule,
    FormsModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    NgOptimizedImage,
    RouterModule,
    MatCardModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectCountryModule.forRoot( 'en' ),
    TranslateModule,
    SharedModule,
    MatExpansionModule,
    MatDividerModule,
    MatChipsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatMenuModule,
    FormsModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    NgOptimizedImage,
    MatSelectCountryModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    LucideAngularModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    MatOptionModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatTooltip,
    MatSelect,
    JobComponent,
  ],
  providers: [ TranslateService, RegistrationPageService, {
    provide: MatSelectCountryLangToken,
    useValue: 'en',
  }, importProvidersFrom( TranslateModule.forRoot() ),
  ],
} )
export class PagesModule {
}
